import React, { useEffect } from 'react';
import RejectionAlert from '../Request/RejectionAlert';
import { withRouter } from 'react-router-dom';

const FireRejection = ({ location }) => {


  return <RejectionAlert />;
};

export default withRouter(FireRejection);
